import React from 'react';

const Loading = () => {
	return (
		<>
			<div className="relative">
				<div className="w-100px h-100px rounded-full border-8 border-primary animate-spin border-t-transparent relative border-b-transparent"></div>
				<h1 className="text-primary absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 font-black text-6xl">
					C
				</h1>
			</div>
		</>
	);
};

export default Loading;